module.exports = __webpack_public_path__ + "img/no-hotel.7b53826d.jpg";